(function() {
  var KEY = 'pared_wishlist';

  function getList() {
    try { return JSON.parse(localStorage.getItem(KEY) || '[]'); } catch(e) { return []; }
  }
  function saveList(list) {
    try { localStorage.setItem(KEY, JSON.stringify(list)); } catch(e) {}
  }
  function inList(id) {
    return getList().some(function(i) { return String(i.id) === String(id); });
  }
  function toggle(id, handle, title, image) {
    var list = getList();
    var idx = -1;
    for (var k = 0; k < list.length; k++) { if (String(list[k].id) === String(id)) { idx = k; break; } }
    if (idx >= 0) { list.splice(idx, 1); saveList(list); return false; }
    list.push({ id: String(id), handle: handle, title: title, image: image });
    saveList(list); return true;
  }

  function heartSVG(filled) {
    return '<svg viewBox="0 0 24 24" width="18" height="18" xmlns="http://www.w3.org/2000/svg"><path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"' +
      (filled ? ' fill="currentColor"' : ' fill="none" stroke="currentColor" stroke-width="2"') + '/></svg>';
  }

  function updateCount() {
    var n = getList().length;
    document.querySelectorAll('.pared-wish-count').forEach(function(b) {
      b.textContent = n || '';
      b.style.display = n ? '' : 'none';
    });
  }

  // ── Header icon ──────────────────────────────────
  function injectHeader() {
    if (document.querySelector('.pared-wish-header')) return;
    var cartDrawer = document.querySelector('cart-drawer-component');
    if (!cartDrawer) return;
    var n = getList().length;
    var a = document.createElement('a');
    a.href = '/pages/favoritos';
    a.className = 'pared-wish-header header-actions__action button-unstyled';
    a.setAttribute('aria-label', 'Mis favoritos');
    a.innerHTML = heartSVG(false) + '<span class="pared-wish-count" style="' + (n ? '' : 'display:none') + '">' + (n || '') + '</span>';
    cartDrawer.parentElement.insertBefore(a, cartDrawer);
  }

  // ── Card buttons ──────────────────────────────────
  function injectCards() {
    document.querySelectorAll('product-card[data-product-id]').forEach(function(card) {
      if (card.querySelector('.pared-wish-btn')) return;
      var id = card.dataset.productId;
      var link = card.querySelector('a[href*="/products/"]');
      var handle = '';
      if (link) { var m = link.href.match(/\/products\/([^/?#]+)/); handle = m ? m[1] : ''; }
      var titleEl = card.querySelector('h3, h2');
      var title = titleEl ? titleEl.textContent.trim() : '';
      var imgEl = card.querySelector('img');
      var image = imgEl ? (imgEl.dataset.src || imgEl.src) : '';

      var btn = document.createElement('button');
      btn.type = 'button';
      var active = inList(id);
      btn.className = 'pared-wish-btn' + (active ? ' pared-wish-btn--active' : '');
      btn.setAttribute('aria-label', 'Agregar a favoritos');
      btn.setAttribute('data-product-id', id);
      btn.innerHTML = heartSVG(active);

      btn.addEventListener('click', function(e) {
        e.preventDefault(); e.stopPropagation();
        var added = toggle(id, handle, title, image);
        document.querySelectorAll('.pared-wish-btn[data-product-id="' + id + '"]').forEach(function(b) {
          b.classList.toggle('pared-wish-btn--active', added);
          b.innerHTML = heartSVG(added);
        });
        updateCount();
      });

      var gallery = card.querySelector('.card-gallery');
      if (gallery) gallery.appendChild(btn);
    });
  }

  // ── Product page button ───────────────────────────
  function injectProductPage() {
    if (!window.__pared_product) return;
    if (document.querySelector('.pared-wish-product-btn')) return;
    var p = window.__pared_product;
    var anchor = document.querySelector('.buy-buttons-block, buy-buttons, [class*="buy-buttons-block"]');
    if (!anchor) return;
    var active = inList(p.id);
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'pared-wish-product-btn' + (active ? ' pared-wish-btn--active' : '');
    btn.innerHTML = heartSVG(active) + '<span>' + (active ? 'Guardado en favoritos' : 'Guardar en favoritos') + '</span>';
    btn.addEventListener('click', function() {
      var added = toggle(p.id, p.handle, p.title, p.image);
      btn.classList.toggle('pared-wish-btn--active', added);
      btn.innerHTML = heartSVG(added) + '<span>' + (added ? 'Guardado en favoritos' : 'Guardar en favoritos') + '</span>';
      updateCount();
    });
    anchor.insertAdjacentElement('afterend', btn);
  }

  // ── Wishlist page ─────────────────────────────────
  function renderPage() {
    var el = document.querySelector('#pared-wishlist-container');
    if (!el) return;
    var list = getList();
    if (list.length === 0) {
      el.innerHTML = '<div class="pared-wishlist-empty"><p>No tenés obras guardadas todavía.</p>' +
        '<a href="/collections/all" class="button button--primary">Explorar obras</a></div>';
      return;
    }
    el.innerHTML = '<ul class="pared-wishlist-grid">' + list.map(function(item) {
      return '<li class="pared-wishlist-item"><a href="/products/' + item.handle + '">' +
        (item.image ? '<div class="pared-wishlist-item__img"><img src="' + item.image + '" alt="' + item.title + '" loading="lazy"></div>' : '') +
        '<p class="pared-wishlist-item__title">' + item.title + '</p></a>' +
        '<button class="pared-wish-remove" data-id="' + item.id + '" type="button" aria-label="Quitar">&#10005;</button></li>';
    }).join('') + '</ul>';
    el.querySelectorAll('.pared-wish-remove').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var id = btn.dataset.id;
        saveList(getList().filter(function(i) { return i.id !== id; }));
        renderPage(); updateCount();
      });
    });
  }

  // ── Init ──────────────────────────────────────────
  function init() {
    injectHeader();
    injectCards();
    injectProductPage();
    renderPage();
    var observer = new MutationObserver(injectCards);
    var root = document.querySelector('.product-grid, main');
    if (root) observer.observe(root, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', init); }
  else { init(); }

  window.ParedWishlist = { getList: getList, toggle: toggle };
})();